import { Type } from "@sinclair/typebox";
import { isoTimestampSchema, opaqueIdSchema } from "./common.js";
export const jobStateSchema = Type.Union([
    Type.Literal("queued"),
    Type.Literal("active"),
    Type.Literal("retry_wait"),
    Type.Literal("completed"),
    Type.Literal("failed"),
    Type.Literal("cancelled")
]);
export const jobReferenceSchema = Type.Object({
    id: Type.String({ minLength: 1, maxLength: 200 }),
    kind: Type.String({ minLength: 1, maxLength: 100 }),
    state: jobStateSchema,
    progressCurrent: Type.Optional(Type.Integer({ minimum: 0 })),
    progressTotal: Type.Optional(Type.Integer({ minimum: 0 })),
    message: Type.Optional(Type.String({ maxLength: 500 })),
    subjectId: Type.Optional(opaqueIdSchema),
    createdAt: isoTimestampSchema,
    updatedAt: isoTimestampSchema
}, { $id: "JobReference", additionalProperties: false });
export const jobEventSchema = Type.Object({
    sequence: Type.Integer({ minimum: 0 }),
    job: jobReferenceSchema
}, { $id: "JobEvent", additionalProperties: false });
//# sourceMappingURL=jobs.js.map